import * as React from 'react';
import { LatestNewsTitleContainer, LatestNewsTitleContent } from './components';

export const LatestNewsTitle = (props: {
  id: string,
}) => {
  const {
    id,
  } = props;
  return (
    <LatestNewsTitleContainer id={id}>
      <LatestNewsTitleContent id={id} />
    </LatestNewsTitleContainer>
  );
};
